import type { CalendarEvent } from '@/services/business/calendar';
import type { StaffCalendarEvent, DirectorCalendarEvent } from '@/hooks/useStaffCalendarData';
import type { CsmCalendarEvent } from '@/hooks/useCsmCalendarData';

export type CalendarItem =
  | CalendarEvent
  | StaffCalendarEvent
  | DirectorCalendarEvent
  | CsmCalendarEvent;

export const isStaffTaskEvent = (item: CalendarItem): item is StaffCalendarEvent =>
  item.type === 'staff_task';

export const isDirectorShootingEvent = (item: CalendarItem): item is DirectorCalendarEvent =>
  item.type === 'director_shooting';

export const isCsmTaskEvent = (item: CalendarItem): item is CsmCalendarEvent =>
  item.type === 'csm_task';
